// import request from '@/utils/request'
import { listParkingSpaces } from '@/api/parking/parkingSpace'
import { listCommunity } from '@/api/parking/community'

/**
 * Load business entity options based on business type
 */
export function loadBusinessEntityOptions(businessType) {
  const type = parseInt(businessType);
  console.log(`Loading business entities for type: ${type}`);

  return new Promise((resolve) => {
    switch (type) {
      case 1: // Parking
        listParkingSpaces({pageSize: 1000}).then(response => {
          console.log("Raw parking spaces response:", response);

          let dataArray = [];
          if (response && response.code === 200 && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (response && Array.isArray(response)) {
            dataArray = response;
          } else if (response && response.data && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (response && response.rows && Array.isArray(response.rows)) {
            dataArray = response.rows;
          }

          console.log("Processed parking spaces:", dataArray);
          resolve({ data: dataArray });
        }).catch(error => {
          console.error("Error loading parking spaces:", error);
          resolve({ data: [] });
        });
        break;

      case 2: // Charging - placeholder until implemented
        resolve({ data: [] });
        break;

      case 3: // Wash - placeholder until implemented
        resolve({ data: [] });
        break;

      case 4: // Property/Community
        // Use listCommunity instead of getCommunityOptionList for more data
        listCommunity({pageSize: 1000}).then(response => {
          console.log("Raw community response:", response);

          let dataArray = [];
          if (response && response.code === 200 && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (response && Array.isArray(response)) {
            dataArray = response;
          } else if (response && response.data && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (response && response.rows && Array.isArray(response.rows)) {
            dataArray = response.rows;
          }
          
          console.log("Processed community data:", dataArray);
          resolve({ data: dataArray });
        }).catch(error => {
          console.error("Error loading community data:", error);
          resolve({ data: [] });
        });
        break;

      default:
        console.log(`No handler for business type ${type}, returning empty array`);
        resolve({ data: [] });
    }
  });
}